<template>
  <div>
    <v-form v-model="isFormValid">
      <h2>運営ユーザー編集</h2>

      <v-progress-linear v-if="isLoading" indeterminate />

      <v-container class="mt-4">
        <v-row align="center">
          <v-col cols="6">
            <h5>姓*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.lastName"
              :rules="[required]"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>名*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.firstName"
              :rules="[required]"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>姓（カナ）*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.lastNameKana"
              :rules="[required, isKatakana]"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>名（カナ）*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.firstNameKana"
              :rules="[required, isKatakana]"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- <v-row align="center">
        <v-col cols="6">
          <h5>性別*</h5>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="inputValue.gender"
            :rules="[required]"
            :items="genderItems"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-select>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="6">
          <h5>生年月日*</h5>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="inputValue.dateOfBirth"
            :rules="[required]"
            variant="outlined"
            hide-details=""
            density="compact"
            type="date"
          ></v-text-field>
        </v-col>
      </v-row> -->

        <v-row align="center">
          <v-col cols="6">
            <h5>メールアドレス*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.email"
              :rules="[required]"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- <v-row align="center">
        <v-col cols="6">
          <h5>住所*</h5>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="inputValue.address"
            :rules="[required]"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="6">
          <h5>建物・部屋番号</h5>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="inputValue.building"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row> -->

        <!-- <v-row align="center">
        <v-col cols="6">
          <h5>電話番号*</h5>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="inputValue.phoneNumber"
            :rules="[required, isTel]"
            label="ハイフンあり"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row> -->

        <v-row align="center">
          <v-col cols="6">
            <h5>管理者</h5>
          </v-col>
          <v-col cols="6">
            <v-checkbox v-model="inputValue.isAdmin" hide-details=""></v-checkbox>
          </v-col>
        </v-row>
      </v-container>

      <div class="d-flex justify-center mt-6">
        <v-btn
          v-if="userId"
          @click="updateUser"
          :disabled="isLoading || !isFormValid || (user && user.isDisabled)"
          color="primary"
          depressed
          large
          >保存</v-btn
        >
        <v-btn
          v-else
          @click="createUser"
          :disabled="isLoading || !isFormValid"
          color="primary"
          depressed
          large
          >作成</v-btn
        >
      </div>

      <div v-if="userId && user" class="d-flex justify-center mb-8 mt-10">
        <v-btn @click="deleteUser" :disabled="user.isDisabled" color="error" depressed>
          <div v-if="user && user.isDisabled">ユーザー削除済み</div>
          <div v-else>ユーザー削除</div>
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script lang="ts">
import { PutUserRequst } from "@/api/ApiUser";
import ValidationMixin from "@/mixins/ValidationMixin";
import LocalDataService from "@/service/LocalDataService";
import { userModule } from "@/store/dataModule/userModule";
import { OperationUserResponse } from "chaild-api/lib";
import { defineComponent } from "vue";
export default defineComponent({
  mixins: [ValidationMixin],

  async mounted() {
    if (this.userId) {
      await this.getUser();
    } else {
      this.inputValue.isAdmin = false;
    }
  },

  data() {
    return {
      isLoading: false,
      isFormValid: false,
      inputValue: {} as PutUserRequst,
      genderItems: [
        { text: "男性", value: "male" },
        { text: "女性", value: "female" },
      ],
    };
  },

  computed: {
    userId: function () {
      return this.$route.params.userId;
    },
    user: function (): OperationUserResponse | null {
      return userModule.user;
    },
  },

  methods: {
    async getUser() {
      this.isLoading = true;
      if (this.userId) {
        const userId = Array.isArray(this.userId)
          ? this.userId[0]
          : this.userId;

        const response = await userModule.getUser({
          userId,
        });

        // 【修正ポイント】取得したデータを inputValue にコピーする
        // これにより v-model で紐付いている各入力項目に値が入ります
        if (response) {
          this.inputValue = {
              ...response,
              // 取得したデータに値がない場合のデフォルト値をセット
              dateOfBirth: (response as any).dateOfBirth || "", 
              gender: (response as any).gender || "male",
          } as PutUserRequst;
        }
      }
      this.isLoading = false;
    },
    async updateUser() {
      this.isLoading = true;
      if (this.userId) {
        if (this.inputValue.building == "") {
          this.inputValue.building = undefined;
        }
        await userModule.updateUser({
          ...this.inputValue,
        })
        .catch((e) => {
          this.isLoading = false;
        });
        this.$router.push({ path: "/admin-user" });
      }
      this.isLoading = false;
    },
    async createUser() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId && this.inputValue) {
        if (this.inputValue.building == "") {
          this.inputValue.building = undefined;
        }
        const response = await userModule
          .createUser({
            companyId,
            ...this.inputValue,
          })
          .catch((e) => {
            alert("不正な値が含まれているか、メールアドレスが既存のユーザーと重複しています");
          });
        if (response) {
          this.$router.push({ path: "/admin-user" });
        }
      }
      this.isLoading = false;
    },
    async deleteUser() {
      const answer = confirm("ユーザーを削除しますか？");
      if (answer && this.userId) {
        this.isLoading = true;

        const userId = Array.isArray(this.userId)
          ? this.userId[0]
          : this.userId;

        await userModule.deleteUser({
          userId,
        });

        this.$router.push({ path: "/admin-user" });
        this.isLoading = false;
      }
    },
  },
});
</script>
